import { useTranslation, useProperty } from '@eti/providers';
import { css } from '@eti/styles';
import { Card, Inline, breakpoints, vars } from '@etg/wings';
import { ThumbsUp } from '@phosphor-icons/react';

const motivationalTextStyles = css`
  line-height: 21px;
`;

const iconContainerStyles = css`
  background-color: ${vars.colors.promotional.background};
  border-radius: 50%;
  display: inline-flex;
  padding: 16px;

  @media (max-width: ${breakpoints._360}) {
    height: 40px;
    padding: 10px;
    width: 40px;
  }
`;

const MotivationalNotification = () => {
  const { p } = useProperty();
  const { t } = useTranslation();

  return p('TravelerDetails.MotivationalCopy.Enabled') ? (
    <Card data-testid="motivational-notification">
      <Inline alignY="center" noWrap spacing={{ [breakpoints._0]: 16, [breakpoints._360]: 24 }}>
        <div className={iconContainerStyles}>
          <ThumbsUp color={vars.colors.promotional.foreground} size={20} weight="light" />
        </div>
        <p className={motivationalTextStyles}>{t('TravelerDetails.MotivationalCopy.Text')}</p>
      </Inline>
    </Card>
  ) : null;
};

export default MotivationalNotification;
